<template>
    <div class="input">
        <label :for="name" class="label">{{ label }}</label>
        <div class="container" :class="{ disabled }">
            <input autocomplete autofocus :id="name" @input="$emit('update:modelValue', $event.target.value)"
                :placeholder="placeholder" required :value="modelValue" :type="inputType" :disabled="disabled">
            <img class="showHidePass" :src="showPassLogo" v-if="showIcon" v-show="inputType == 'password'"
                @click="toggleIconPass" />
            <img class="showHidePass" :src="hidePassLogo" v-if="showIcon" v-show="inputType == 'text'"
                @click="toggleIconPass" />
        </div>
    </div>
</template>
<script>
import showPassLogo from "../../assets/logos/view.png";
import hidePassLogo from "../../assets/logos/hide.png";
import devLogo from "../../assets/logos/dev-logo.png"

export default {
    name: 'InputContent',
    props: {
        disabled: {
            default: false,
        },
        label: {
            type: String,
            value: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            value: '',
        },
        type: {
            type: String,
            value: '',
            required: true,
        },
    },
    data() {
        return {
            devLogo,
            hidePassLogo,
            showPassLogo,
            icon: showPassLogo,
            inputType: this.type,
        }
    },
    emits: [
        'update:modelValue',
    ],
    methods: {
        toggleIconPass() {
            this.inputType = this.inputType === "password" ? "text" : "password"
        },
    },
    computed: {
        showIcon() {
            return this.type === "password";
        }
    },

}
</script>

<style lang="scss" scoped>
@import '../../assets/utilities/_variables.scss';

.input {
    margin-bottom: 20px;

    label {
        margin: 10px 0 10px 0;
        width: 100%;
        margin: 0;
        margin-left: 5px;
        text-transform: capitalize;
        font-size: small;
    }

    .container {
        background-color: var(--bg-color-2);
        display: flex;
        position: relative;
        border: 1px solid rgba(var(--black), .3);
        border-radius: 5px;
        height: 3em;
        overflow: hidden;

        &.disabled {
            opacity: .6;
        }
        
        input {
            padding: 0 1em;
            border: none;
            color: var(--text-color);
            background: var(--bg-color-2);
            display: block;
            width: 100%;
            height: 100%;
            outline: none;
            border: 2px solid var(--bg-color-2);
    
            &:focus {
                border-color: var(--highlight-color);
                box-shadow: 0 0 0 1px var(--highlight-color), inset 0 0 0 1px var(--highlight-color);
            }
        }
        .showHidePass {
            cursor: pointer;
            height: 100%;
            padding: .75em;
            user-select: none;
            -webkit-user-drag: none;
            fill: var(--text-color);
        }
    }
}
</style>
